import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { pageTitle, tabRail } from '../app/glass/styles';
import Products from './Products';
import CreateInbound from './CreateInbound';
import Inbounds from './Inbounds';

const TABS = [
  ['stock', 'navigation.products'],
  ['send', 'navigation.sendInventory'],
  ['history', 'navigation.inventoryHistory'],
];

export default function InventoryPage() {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const tab = TABS.some(([k]) => k === tabParam) ? tabParam : 'stock';
  const setTab = (key) => {
    const next = new URLSearchParams(searchParams);
    if (key === 'stock') next.delete('tab');
    else next.set('tab', key);
    setSearchParams(next, { replace: true });
  };

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: 24, marginTop: 6 }}>
        <div style={pageTitle}>{t('navigation.inventory')}</div>
      </div>
      <div className="cz-wrap" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div className="cz-scroll-x" style={tabRail}>
          {TABS.map(([key, label]) => (
            <button key={key} type="button" className={`cz-tab ${tab === key ? 'on' : ''}`} onClick={() => setTab(key)}>
              {t(label)}
            </button>
          ))}
        </div>
      </div>
      {tab === 'stock' && <Products />}
      {tab === 'send' && <CreateInbound />}
      {tab === 'history' && <Inbounds />}
    </>
  );
}
